import React from 'react';
import styled from 'styled-components';
import { Button } from './Button';
import HomeImg from '../assets/living.jpg';

const Hero = () => {
    return (
        <HeroContainer>
            <HeroBg>
                <HomeImgBg src={HomeImg} alt="Home" />
            </HeroBg>

            <HeroContent>
                <HeroItems>
                    <HeroH1>Create Your Space</HeroH1>
                    <HeroPara>Design your dream home space</HeroPara>
                    <Button primary="true" big="true" to="/all">Enter Shop</Button>
                </HeroItems>
            </HeroContent>
        </HeroContainer>
    )
}

export default Hero


const HeroContainer = styled.div`
    background: #000;
    display: flex;
    justify-content: center;
    align-items:center;
    color: #fff;
    height: 100vh;
    position: relative;
    margin-top: -80px;

    :before {
        content: "";
        position: absolute;
        top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 2;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.6) 100%
    ), linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, transparent 100%)
    }
`

const HeroBg = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
`

const HomeImgBg = styled.img`
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit:cover;
`

const HeroContent = styled.div`
    z-index: 3;
    height: calc(100vh - 80px);
    max-height: 100%;
    padding: 0rem calc((100vw - 1300px) / 2);
`

const HeroItems = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100vh;
    max-height: 100%;
    padding: 0;
    color: #fff;
    line-height: 1.1;
    font-weight: bold;
`

const HeroH1 = styled.h1`
    font-size: clamp(1.5rem, 6vw, 4rem);
    margin-bottom: 1.5rem;
    letter-spacing: 3px;
    padding: 0 1rem;
`

const HeroPara = styled.p`
    font-size: clamp(1rem, 3vw, 1.5rem);
    margin-bottom: 2rem;
    font-weight: 400;
`